import api from '~/services/api';
import { JSONShipment } from '~/types/Shipment';

/*
const mockRates = [
  {
    object_created: '2018-07-02T22:26:10.051Z',
    object_id: 'b4c31364ebe5422abe813743fa462fd2',
    object_owner: 'malcolm_fdv@shippo.com',
    shipment: '696440821bea41fb8ecc5d51c6b458cf',
    attributes: ['BESTVALUE', 'CHEAPEST', 'FASTEST'],
    amount: '6.70',
    currency: 'USD',
    amount_local: '6.70',
    currency_local: 'USD',
    provider: 'USPS',
    provider_image_75: 'https://dev-qa-static-shippodev-com.s3.amazonaws.com/providers/75/USPS.png',
    provider_image_200:
      'https://dev-qa-static-shippodev-com.s3.amazonaws.com/providers/200/USPS.png',
    servicelevel: { name: 'Priority Mail', token: 'usps_priority', terms: '' },
    estimated_days: 2,
    arrives_by: null,
    duration_terms:
      'Delivery within 1, 2, or 3 days based on where your package started and where it’s being sent.',
    messages: [],
    carrier_account: '74d15383268c4476a85e4677b2b679df',
    test: false,
    zone: '1',
  },
  {
    object_created: '2018-07-02T22:43:07.012Z',
    object_id: '2a705219dd21460ea296e468f4e9611a',
    object_owner: 'malcolm_fdv@shippo.com',
    shipment: '9680673b91014b39a07c52956c7c6003',
    attributes: ['BESTVALUE', 'CHEAPEST'],
    amount: '27.92',
    currency: 'USD',
    amount_local: '27.92',
    currency_local: 'USD',
    provider: 'UPS',
    provider_image_75: 'https://dev-qa-static-shippodev-com.s3.amazonaws.com/providers/75/UPS.png',
    provider_image_200:
      'https://dev-qa-static-shippodev-com.s3.amazonaws.com/providers/200/UPS.png',
    servicelevel: { name: 'Next Day Air Saver®', token: 'ups_next_day_air_saver', terms: '' },
    estimated_days: 1,
    arrives_by: '15:00:00',
    duration_terms:
      'Next business day delivery by 3:00 or 4:30 p.m. for commercial destinations and by end of day for residentail destinations.',
    messages: [],
    carrier_account: '95011f825f314edea9ce247ea6e8ecf7',
    test: false,
    zone: null,
  },
  {
    object_created: '2018-07-02T22:43:07.011Z',
    object_id: 'd3043b76cfe340c9b6974e5fa67ff55b',
    object_owner: 'malcolm_fdv@shippo.com',
    shipment: '9680673b91014b39a07c52956c7c6003',
    attributes: [],
    amount: '30.14',
    currency: 'USD',
    amount_local: '30.14',
    currency_local: 'USD',
    provider: 'UPS',
    provider_image_75: 'https://dev-qa-static-shippodev-com.s3.amazonaws.com/providers/75/UPS.png',
    provider_image_200:
      'https://dev-qa-static-shippodev-com.s3.amazonaws.com/providers/200/UPS.png',
    servicelevel: { name: 'Next Day Air®', token: 'ups_next_day_air', terms: '' },
    estimated_days: 1,
    arrives_by: '10:30:00',
    duration_terms:
      'Next business day delivery by 10:30 a.m., 12:00 noon, or end of day, depending on destination.',
    messages: [],
    carrier_account: '95011f825f314edea9ce247ea6e8ecf7',
    test: false,
    zone: null,
  },
  {
    object_created: '2018-07-02T22:43:07.010Z',
    object_id: 'e262077b447f4307ae4f220e57fd1aac',
    object_owner: 'malcolm_fdv@shippo.com',
    shipment: '9680673b91014b39a07c52956c7c6003',
    attributes: ['FASTEST'],
    amount: '62.46',
    currency: 'USD',
    amount_local: '62.46',
    currency_local: 'USD',
    provider: 'UPS',
    provider_image_75: 'https://dev-qa-static-shippodev-com.s3.amazonaws.com/providers/75/UPS.png',
    provider_image_200:
      'https://dev-qa-static-shippodev-com.s3.amazonaws.com/providers/200/UPS.png',
    servicelevel: {
      name: 'Next Day Air Early A.M.®',
      token: 'ups_next_day_air_early_am',
      terms: '',
    },
    estimated_days: 1,
    arrives_by: '08:30:00',
    duration_terms: 'Next business day delivery by 8:30 a.m., 9:00 a.m., or 9:30 a.m. ',
    messages: [],
    carrier_account: '95011f825f314edea9ce247ea6e8ecf7',
    test: false,
    zone: null,
  },
  {
    object_created: '2018-07-02T22:26:10.051Z',
    object_id: 'b4c31364ebe5422abe813743fa462f43',
    object_owner: 'malcolm_fdv@shippo.com',
    shipment: 'e65dc0ed17164410823187c2ceed1f62',
    attributes: ['BESTVALUE', 'CHEAPEST', 'FASTEST'],
    amount: '6.75',
    currency: 'USD',
    amount_local: '6.75',
    currency_local: 'USD',
    provider: 'USPS',
    provider_image_75: 'https://dev-qa-static-shippodev-com.s3.amazonaws.com/providers/75/USPS.png',
    provider_image_200:
      'https://dev-qa-static-shippodev-com.s3.amazonaws.com/providers/200/USPS.png',
    servicelevel: { name: 'Priority Mail', token: 'usps_priority', terms: '' },
    estimated_days: 2,
    arrives_by: null,
    duration_terms:
      'Delivery within 1, 2, or 3 days based on where your package started and where it’s being sent.',
    messages: [],
    carrier_account: '74d15383268c4476a85e4677b2b679df',
    test: false,
    zone: '1',
  },
];


const ratesByShipment = {
  '696440821bea41fb8ecc5d51c6b458cf': ['b4c31364ebe5422abe813743fa462fd2'],
  '9680673b91014b39a07c52956c7c6003': [
    '2a705219dd21460ea296e468f4e9611a',
    'd3043b76cfe340c9b6974e5fa67ff55b',
    'e262077b447f4307ae4f220e57fd1aac',
  ],
  e65dc0ed17164410823187c2ceed1f62: ['b4c31364ebe5422abe813743fa462f43'],
};
*/

// TODO: This goes to https://service-dev-qa.shippodev.com/shipments/1fb7a041832946f388633e65a62189a3/rates/?results=200
function getRates(shipmentId: string) {
  return api.request<JSONShipment>({
    url: `/shipments/${shipmentId}`,
    method: 'GET',
  });
}

export { getRates };
